import React from 'react';
import Header from '../../header';
import AuthListener from "../../auth/auth_listener";
import EmailNotVerifiedMessage from '../../pages/signup/not_verified_banner';

const VERIFY_EMAIL_HEADER_EXCLUSION_PATHS = [
  '/verify-email'
]

const BaseLayout = (props) => {
  const { childLayout, displayHeader=true } = props;

  return (
    <section className="container-fluid">
      <AuthListener />

      <div className="row page-container">
        <div className="col">
          <div className="row header-error">
            {VERIFY_EMAIL_HEADER_EXCLUSION_PATHS.indexOf(location.pathname) < 0 && <EmailNotVerifiedMessage />}
          </div>
          {
            displayHeader === true &&
            <div className="row header-row">
              <div className="col simple-container">
                <Header />
              </div>
            </div>
          }
          <div className="row simple-container">
            {childLayout}
          </div>
        </div>
      </div>
    </section>
  )  
}

export default BaseLayout;